import { getAsset } from "@/utils/assets"
/**
 * 特殊会话系统常量配置
 * 包括系统特殊用户 ID 和特殊会话配置
 */

/**
 * 系统特殊用户 ID（区分正式环境和测试环境）
 */
export const SPECIAL_USER_IDS = {
  SYSTEM: {
    uid: 10000,
    encrypted_id: 'fdfa5790b20cebd20cbe35b686ffdd20'
  },
  CUSTOMER_SERVICE: {
    uid: 10001,
    encrypted_id: 'ae3c33e53c75b1206a162eca61c2d3b7'
  },
  CALL_RECORD: {
    uid: 10002,
    encrypted_id: '2d472d49b128ef094bc954e41c826272'
  },
  TEAM: {
    uid: 10003,
    encrypted_id: '9542a6bf4faf81643c6086731014ea77'
  },
  SAY_HELLO: {
    uid: 1,
    mock_id: 'SAY_HELLO_MOCK_ID'
  },
  VISITORS: {
    uid: 2,
    mock_id: 'VISITORS_MOCK_ID'
  },
  INTERACTION: {
    uid: 2,
    mock_id: 'INTERACTION_MOCK_ID'
  }
}

export const STRANGER_CONVERSATION = {
  conversation_id: 'STRANGER_MESSAGE',
  target_nick_name: 'Stranger Messages',
  target_avatar_url: getAsset('@/assets/images/icons/message-news.svg'),
  preview: 'Welcome to Misslive!',
  rank: 1000,
  is_special: true,
}

export const SYSTEM_CONVERSATION = {
  // conversation_id: 'SYSTEM_MESSAGE',
  target_nick_name: 'System Notification',
  target_avatar_url: getAsset('@/assets/images/icons/message-notification.svg'),
  preview: 'Welcome to Misslive!',
  rank: 1000,
  target_uid: SPECIAL_USER_IDS.SYSTEM.encrypted_id,
  member_id: SPECIAL_USER_IDS.SYSTEM.uid,
  is_special: true,
}

export const CUSTOMER_CONVERSATION = {
  // conversation_id: 'CUSTOMER_SERVICE',
  target_nick_name: 'Customer Service',
  target_avatar_url: getAsset('@/assets/images/icons/message-services.svg'),
  preview: 'Welcome to Misslive!',
  rank: 1000,
  target_uid: SPECIAL_USER_IDS.CUSTOMER_SERVICE.encrypted_id,
  member_id: SPECIAL_USER_IDS.CUSTOMER_SERVICE.uid,
  is_special: true,
}

export const TEAM_CONVERSATION = {
  // conversation_id: 'TEAM_MESSAGE',
  target_nick_name: 'Misslive Team',
  target_avatar_url: getAsset('@/assets/images/icons/message-team.png'),
  preview: 'Welcome to Misslive!',
  rank: 1000,
  target_uid: SPECIAL_USER_IDS.TEAM.encrypted_id,
  member_id: SPECIAL_USER_IDS.TEAM.uid,
  is_special: true,
}

/**
 * 特殊会话配置（头像、名称、默认预览等）
 */
export const SPECIAL_CONVERSATIONS = [
  SYSTEM_CONVERSATION,
  CUSTOMER_CONVERSATION,
  TEAM_CONVERSATION,
]

/**
 * 消息已读回执类型
 */
export const MSG_READ_TYPE = {
  ENTER: 0,  // 进入会话
  STAY: 1,   // 停留在会话
  QUIT: 2,   // 退出会话
}
